import { useState } from "react";
import { Link } from "react-router-dom";
import { faq } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section className="bg-background-100">
        <div className="mx-auto max-w-4xl px-4 py-16 md:px-6 md:py-20">
          <div className="text-center">
            <p className="text-xs font-medium tracking-[0.3em] text-primary-600">FAQ</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              追更前常见问题
            </h2>
            <div className="gold-line mx-auto mt-4 h-px w-16"></div>
          </div>

          <div className="mt-10 space-y-3">
            {faq.map((item, i) => {
              const open = openIndex === i;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h3 className="font-heading text-base text-foreground-950">{item.q}</h3>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-600">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faq.map((item) => ({
                "@type": "Question",
                name: item.q,
                acceptedAnswer: { "@type": "Answer", text: item.a },
              })),
            }),
          }}
        />
      </section>

      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Golden%20sunrise%20over%20a%20serene%20Chinese%20cultivation%20sect%20valley%2C%20warm%20vermilion%20and%20gold%20light%2C%20soft%20ink%20wash%20mountains%20and%20flying%20cranes%2C%20hopeful%20uplifting%20atmosphere%2C%20cinematic%2C%20refined%20detail&width=1920&height=720&seq=cta-home-01&orientation=landscape"
            alt="朝霞中的修仙门派山谷暖景"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/70 to-background-950/40"></div>
        <div className="relative mx-auto max-w-7xl px-4 py-20 md:px-6 md:py-24">
          <div className="max-w-xl">
            <p className="font-[Ma_Shan_Zheng] text-3xl text-accent-300 md:text-4xl">把关系理清了，再入江湖</p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              人物关系、师姐互动、CP 线与师门日常，一站补全
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-100/80">
              从核心人物到暗线伏笔，从名场面到发展脉络，这里的整理专为追更而备。
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/relations"
                className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                开始补课
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md border border-background-100/30 px-7 py-3 text-sm text-foreground-50 transition-colors hover:bg-background-50/10"
              >
                了解本站
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}